import LineArrowsSwapHorizontalIcon from 'LuxKit/Icons/line/LineArrowsSwapHorizontalIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { FlightsFareTypes } from 'constants/flight'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { useContext } from 'react'
import { useIntl } from 'react-intl'

function FlightsDatesModalFooter() {
  const { flights, fareType } = useContext(FlightSearchWidgetStateContext)
  const { checkinDate, checkoutDate } = flights[0]
  const intl = useIntl()

  const selectDepartureText = intl.formatMessage({
    id: 'QVMrAE2fe-5JNfgd7B6W',
    defaultMessage: 'Select departure',
    description: 'Placeholder text for departure date selection in flight search modal footer',
  })

  const selectReturnText = intl.formatMessage({
    id: 'iAFYFAHXZNSJdoqYVQkS',
    defaultMessage: 'Select return',
    description: 'Placeholder text for return date selection in flight search modal footer',
  })

  return <Group direction="horizontal" gap={12} verticalAlign="center" horizontalAlign="center">
    <BodyText
      variant="medium"
      weight="bold"
    >
      {!checkinDate && selectDepartureText}
      {checkinDate && intlDateFormatter(checkinDate, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale)}
    </BodyText>
    {fareType.value === FlightsFareTypes.RETURN && <>
      <LineArrowsSwapHorizontalIcon size="XS" />
      <BodyText
        variant="medium"
        weight="bold"
        colour={!checkoutDate && !checkinDate ? 'light-foreground-alt' : undefined}
      >
        {!checkoutDate && selectReturnText}
        {checkoutDate && intlDateFormatter(checkoutDate, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale)}
      </BodyText>
    </>}
  </Group>
}

export default FlightsDatesModalFooter
